document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartInner = document.getElementById('cart-drawer-inner');

    let listenersAdded = false;

    function openCartDrawer() {
        // Add cart event listener
        addEventListeners();

        // Drop chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '1';

        // Show drawer and overlay immediately
        cartDrawer.classList.add('open');
        cartOverlay.classList.remove('hidden');
        cartOverlay.classList.add('visible');
        document.body.classList.add('no-scroll');

        // Then load cart content
        fetchCartContent();
    }
    window.openCartDrawer = openCartDrawer; // Expose function globally. Used in cart-notification.js to open the drawer.
    
    function closeCartDrawer() {
        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('visible');
        cartOverlay.classList.add('hidden');
        cartInner.innerHTML = ''; // Clear content

        document.body.classList.remove('no-scroll');
        // Restore chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '2147483636';
    }

    function fetchCartContent() {
      fetch('/?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.getElementById('shopify-section-cart-drawer');
          if (!content) return;

          // Inject cart content
          cartInner.innerHTML = content.innerHTML;
            

          // Auto-focus checkout button and init shipping
          const checkoutBtn = cartDrawer.querySelector('#checkout');
          if (checkoutBtn) {
            checkoutBtn.focus();
            initShippingCalculator();
          }

          updateCartIconCount();
        });
    }
    
    function updateCartIconCount() {
      const countBubble = document.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      let count = 0;
      const subtotalRow = document.querySelector('.cart-drawer__row--subtotal');
      
      if (subtotalRow) {
        // Get items count from the subtotal row
        count = subtotalRow.dataset.itemsCount || 0;
      } 

      const spanVisible = countBubble.querySelector('span[aria-hidden="true"]');
      const spanScreenReader = countBubble.querySelector('span.visually-hidden');

      if (spanVisible) spanVisible.innerText = count;
      if (spanScreenReader) spanScreenReader.innerText = `${count} item${count === 1 ? '' : 's'}`;
    
    }


    // Bind to cart icon
    const cartTrigger = document.querySelector('[data-drawer-toggle="cart"]');
    if (cartTrigger) {
        cartTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            openCartDrawer();
        });
    }

    function addEventListeners() {
      if (listenersAdded) return;
      listenersAdded = true;

      // Overlay click closes drawer
      cartOverlay.addEventListener('click', closeCartDrawer);

      // Header close button click closes drawer
      document.addEventListener('click', function (e) {
          if (e.target.id === 'cart-drawer-close') {
              closeCartDrawer();
          }
      });

      // ESC key closes drawer
      document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
              closeCartDrawer();
          }
      });

      // Trap focus inside cart drawer when open
      document.addEventListener('keydown', function (e) {
          if (!cartDrawer.classList.contains('open')) return;

          const focusableSelectors = [
              'a[href]',
              'button:not([disabled])',
              'textarea:not([disabled])',
              'input:not([disabled])',
              'select:not([disabled])',
              '[tabindex]:not([tabindex="-1"])'
          ];
          const focusableElements = cartDrawer.querySelectorAll(focusableSelectors.join(', '));
          if (focusableElements.length === 0) return;

          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];

          // Trap Tab key
          if (e.key === 'Tab') {
              if (e.shiftKey && document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
              }
          }
      });

      // Handle remove item clicks
      document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('.cart-drawer__remove');
        if (!removeBtn) return;

        e.preventDefault();
        removeBtn.classList.add('cart-drawer__remove--loading');

        const line = removeBtn.getAttribute('data-line');

        // Disable all remove buttons
        document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = true);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: 0 })
        })
          .then(res => res.json())
          .then(() => {
            fetchCartContent();
            document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = false);
          });
      });

      // Handle quantity changes
      document.addEventListener('change', function (e) {
          if (e.target.matches('.cart-drawer__quantity-select')) {
              const line = e.target.getAttribute('data-line');
              const quantity = parseInt(e.target.value, 10);

              fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: Number(line), quantity: quantity })
              })
                  .then(res => res.json())
                  .then(() => {
                      // Refresh cart drawer
                      fetchCartContent();
                  });
          }
      });

      // Order references
      document.addEventListener('click', function (e) {
        if (e.target.matches('.edit-order-reference')) {
          e.preventDefault();
          const itemKey = e.target.getAttribute('data-order-ref-key');
          const currentReference = e.target.getAttribute('data-order-ref-value') || '';

          editOrderReference(itemKey, currentReference);
        }
      });
      async function editOrderReference(itemKey, currentReference) {
          const input = prompt("Add, edit or remove your order reference(s):", currentReference);
          if (input === null) {
              // User cancelled the prompt, do nothing
              return;
          }

          const newReference = input?.trim();

          // Fetch the cart to get the line item by key
          const cart = await fetch('/cart.js').then(res => res.json());
          const lineItem = cart.items.find(item => item.key === itemKey);
          if (!lineItem) {
              return;
          }

          const existingProperties = { ...(lineItem.properties || {}) };
          if (!newReference || newReference === '') {
              existingProperties['Order Reference(s)'] = "";
          } else {
              existingProperties['Order Reference(s)'] = newReference;
          }

          console.log('Existing properties:', JSON.stringify(existingProperties, null, 2));

          const updates = {'id': itemKey, 'quantity': lineItem.quantity, 'properties': existingProperties};

          // Perform the fetch request
          fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
          })
          .then(response => {
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error(`Cart line item properties update failed. ${response.statusText} ${response.status}`);
              }
          })
          .then((data) => {
              openCartDrawer(); // Refresh the cart drawer
          })
          .catch((error) => {
              console.error('Error:', error, JSON.stringify(updates));
          });
      }

      // Postcode input & change event
      document.addEventListener('input', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          // Handle input event for postcode
          e.target.value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
          if (e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4); // Limit to 4 characters
          }
        }
      });

      document.addEventListener('change', async function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          e.preventDefault();

          const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
          if (shippingCost) {
            shippingCost.classList.add('shimmer');  
            shippingCost.innerText = '&nbsp;'; // Show shimmer effect}
          }
          
          // Handle change event for postcode
          const postcode = e.target.value;

          // Save postcode to local storage
          address.zip = postcode;
          address.city = null; // Reset city as postcode has changed
          address.province = null; // Reset province as postcode has changed
          address.country = null; // Reset country as postcode has changed  

          await getPostcodeDetails(postcode);
          addressIsComplete = () => address.city?.trim() && address.zip?.trim() && address.province?.trim() && address.country?.trim();
          if (addressIsComplete()) {
            getShippingRates(address);
          } 
          else {
            // Display postcode input box
            document.querySelector('.cart-drawer__row--shipping-postcode').classList.remove('hidden');
            const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
            if (shippingCost) {
              shippingCost.classList.remove('shimmer');  
              shippingCost.innerText = 'Enter a valid postcode';
              renderRates([]); // Clear rates display
            }
          }
        }
      });

      // 🚀 ENTER key triggers 'change' manually
      document.addEventListener('keydown', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input') && e.key === 'Enter') {
          e.preventDefault();
          const changeEvent = new Event('change', { bubbles: true });
          e.target.dispatchEvent(changeEvent);
        }
      });

    }

    //////////////////////////////////////////////////////////////
    // Shipping Calculator
    //////////////////////////////////////////////////////////////
    let address = {
      type: null,
      city: null,
      zip: null,
      province: null,
      country: null
    };

    const renderRates = (rates) => {
      const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
      if (!shippingCost) return;
      
      // if (rates.length === 0) {
      //   shippingCost.classList.remove('shimmer');  
      //   return;
      // }

      const subTotalPrice = document.querySelector('.cart-drawer__subtotal-price');
      if (!subTotalPrice) return;
      const totalPrice = document.querySelector('.cart-drawer__total-price');
      if (!totalPrice) return;
     
      //Shipping
      const cheapest = rates.reduce((min, rate) => rate.price < min.price ? rate : min, rates[0]);
      var shippingRate = 0;
      if (cheapest) {
        shippingRate = parseFloat(cheapest.price);
        if (isNaN(shippingRate)) {
          shippingRate = 0; // Fallback to 0 if parsing fails
        }
        const formattedShipping = shippingRate.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        shippingCost.innerText = `$${formattedShipping}`;
        shippingCost.classList.remove('shimmer');
      }

      //Total
      const currentSubTotal = parseFloat(subTotalPrice.dataset.subtotal || "0");
      const newTotal = currentSubTotal + shippingRate;
      totalPrice.dataset.total = newTotal.toFixed(2);
      const formattedTotal = newTotal.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      totalPrice.innerText = `$${formattedTotal}`;

      //Taxes
      const taxAmount = (newTotal / 11).toFixed(2);
      const taxRow = document.querySelector('.cart-drawer__row--taxes');
      if (taxRow) {
        taxRow.innerHTML = `Including $${taxAmount} in taxes`;
      }
    };

    const renderFreeShipping = () => {
      const shippingMessage = document.querySelector('.cart-drawer__shipping-message');
      const shippingCost = document.querySelector('.cart-drawer__shipping-cost');
      if (!shippingMessage || !shippingCost) return;  
        shippingMessage.innerText = "Standard Shipping";
        shippingCost.innerText = "Free";
        shippingCost.classList.remove('shimmer');
    };

    const getShippingRates = async (address) => {
      const wrapper = document.getElementById('wrapper-response');
      if (wrapper) wrapper.style.display = "none";

      const shippingCost = document.querySelector('.cart-drawer__shipping-cost');
      if (shippingCost) {
        shippingCost.classList.add('shimmer');
        shippingCost.innerHTML = '&nbsp;';
      }

      try {
        // Step 1: Prepare shipping rates
        await fetch("/cart/prepare_shipping_rates.json", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ shipping_address: address })
        });

        // Step 2: Poll for rates
        let retryCount = 0;
        const maxRetries = 20;

        const pollRates = async () => {
          retryCount++;
          try {
            const response = await fetch("/cart/async_shipping_rates.json");
            const rawText = await response.text();
            let data = null;
            try {
              data = JSON.parse(rawText);
            } 
            catch (err) {
              console.warn("Failed to parse JSON:", err);
            }

            // If response is OK but data is still not usable, retry
            if (!rawText || data === null || !data.shipping_rates) {
              if (retryCount >= maxRetries) {
                shippingCost.classList.remove('shimmer');
                return;
              }
              setTimeout(pollRates, 500);
              return;
            }

            renderRates(data.shipping_rates);
          } 
          catch (err) {
            shippingCost.classList.remove('shimmer');
          }
        };

        // Start polling after slight delay
        setTimeout(pollRates, 500);

      } catch (err) {
        console.error("Shipping rate fetch error:", err);
        shippingCost.classList.remove('shimmer');
      }
    };

    const getPostcodeDetails = async (postcode) => {
      try {
        const response = await fetch(`https://api.zippopotam.us/AU/${postcode}`);

        address.type = 'postcodelookup';
        address.zip = postcode;
        address.city = null;
        address.province = null;
        address.country = null;

        if (response.ok) {
          const data = await response.json();

          // Use the first place if available
          if (Array.isArray(data.places) && data.places.length > 0) {
            const place = data.places[0];
            address.city = place["place name"] || null;
            address.province = place.state || null;
            address.country = data.country || null;
          }
        }

        localStorage.setItem('shippingLocation', JSON.stringify(address));
      } catch (error) {
        console.error('Error getting postcode details:', error);
      }
    };

    const shopifyCustomerLoggedIn = () => {
      const custInfo = document.getElementById('cart-drawer__customer-info');
      if (custInfo) {
        if (custInfo.dataset.customerDefaultaddress === 'true') {
          address.type = 'shopifyaccountDefaultAddress';
          address.city = custInfo.dataset.customerCity || null;
          address.zip = custInfo.dataset.customerZip || null;
          address.province = custInfo.dataset.customerProvince || null;
          address.country = custInfo.dataset.customerCountry || null;
        }
        else if (custInfo.dataset.customerDefaultaddress === 'false') {
          address.type = 'shopifyaccountNoDefaultAddress';
          address.city = null;
          address.zip = null;
          address.province = null;
          address.country = null;
        }
        else {
          address.type = 'shopifyaccountNoDefaultAddress';
          address.city = null;
          address.zip = null;
          address.province = null;
          address.country = null;
        }
      }
      else {
        address.type = 'guest'
        address.city = null;
        address.zip = null;
        address.province = null;
        address.country = null;
      }
    };

    const freeShipping = () => {
      // Check if any cart item is not eligible for free shipping
      const ineligibleItems = document.querySelectorAll('.cart-drawer__item[data-freeshippingeligible="false"]');
      if (ineligibleItems.length > 0) return false;

      const subtotalPrice = document.querySelector('.cart-drawer__subtotal-price');
      if (!subtotalPrice) return false;

      const subtotal = parseFloat(subtotalPrice.dataset.subtotal);
      if (window.b2b === true) {
        return subtotal > 250; // Free shipping for B2B orders over $250
      }
      return subtotal > 99; // Free shipping for orders over $99
    };

    const getStorageShippingLocation = () => {
      const shippingLocation = localStorage.getItem('shippingLocation');
      if (shippingLocation) {
          try {
            const parsedLocation = JSON.parse(shippingLocation);
            address.type = parsedLocation.type || null;
            address.city = parsedLocation.city || null;
            address.zip = parsedLocation.zip || null;
            address.province = parsedLocation.province || null;
            address.country = parsedLocation.country || null;
          }
          catch (err) {
            address = {
              type: null,
              city: null,
              zip: null,
              province: null,
              country: null
            };
            console.error('Error parsing shipping location:', err);
          }
      } 
      else {
        address = {
          type: null,
          city: null,
          zip: null,
          province: null,
          country: null
        };
      }
    }

    const initShippingCalculator = async () => {
      if (freeShipping()) {
        renderFreeShipping();
        return;
      }

      shopifyCustomerLoggedIn();
      if (address.type === 'shopifyaccountDefaultAddress') {
        getShippingRates(address);
      }
      else {
        getStorageShippingLocation();
        addressIsComplete = () => address.city?.trim() && address.zip?.trim() && address.province?.trim() && address.country?.trim();
        document.querySelector('.cart-drawer__row--shipping-postcode').classList.remove('hidden');
        const postcodeInput = document.querySelector('.cart-drawer__postcode-input');
        if (postcodeInput) {
          const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
          if (shippingCost) {
            shippingCost.classList.remove('shimmer');  
            shippingCost.innerText = 'Enter your postcode';
          }
          if (address.zip) {
            postcodeInput.value = address.zip;
            if (addressIsComplete()) {
              getShippingRates(address);
            }
          }
        }
        
      }
    };
});